import React, { useContext } from 'react';
import { GoPrimitiveDot } from 'react-icons/go';

import { BUSINESS_ONBOARDING_STEP, LEFT_MENU_ONBOARDING_STEPS, ONBOARDING_STEP_UI, OnboardingStepIconMap } from '.';
import { AppContext } from '../Core/AppContext';
import { AppState } from '../Core/AppReducer';

import './style.scss';

const BusinessOnboardingSteps = () => {
  const { store } = useContext(AppContext);
  const { businessOnboardingDetails }: AppState = store;
  const internalStep: BUSINESS_ONBOARDING_STEP = businessOnboardingDetails && businessOnboardingDetails.step;

  let currentStep: ONBOARDING_STEP_UI;
  switch (internalStep) {
    case BUSINESS_ONBOARDING_STEP.EXIT:
    case BUSINESS_ONBOARDING_STEP.ONBOARD_BUSINESS_OWNED:
    case BUSINESS_ONBOARDING_STEP.ONBOARD_BUSINESS_FORM:
    case BUSINESS_ONBOARDING_STEP.ONBOARD_BUSINESS_MATCHING:
      currentStep = ONBOARDING_STEP_UI.BUSINESS_PROFILE;
      break;
    case BUSINESS_ONBOARDING_STEP.ONBOARD_BUSINESS_TUTORIAL:
      currentStep = ONBOARDING_STEP_UI.REWARD_TUTORIAL;
      break;
    case BUSINESS_ONBOARDING_STEP.ONBOARD_BUSINESS_ADD_BANK:
      currentStep = ONBOARDING_STEP_UI.SETUP_BANK_ACCOUNT;
      break;
    case BUSINESS_ONBOARDING_STEP.ONBOARD_BUSINESS_ACTIVATION:
      currentStep = ONBOARDING_STEP_UI.ACTIVATION;
      break;
    case BUSINESS_ONBOARDING_STEP.ONBOARD_BUSINESS_COMMUNITY:
    case BUSINESS_ONBOARDING_STEP.ONBOARD_BUSINESS_WAITLIST:
    case BUSINESS_ONBOARDING_STEP.ONBOARD_BUSINESS_COMPLETE:
      currentStep = ONBOARDING_STEP_UI.JOIN_COMMUNITY;
      break;

    default:
      break;
  }

  return (
    <div className="business-onboarding-steps mx-3 mt-5 text-white">
      <div className="business-onboarding-label font-size-13 py-3">Complete Your Profile</div>
      <div>
        {LEFT_MENU_ONBOARDING_STEPS.map((step: ONBOARDING_STEP_UI) => (
          <GuidedOnboardingStep
            // onboardingUserType={onboardingUserType}
            lastSavedStep={currentStep}
            stepId={step}
            key={step}
          />
        ))}
      </div>
    </div>
  );
};

export default BusinessOnboardingSteps;

type GuidedOnboardingStepProps = {
  stepId: ONBOARDING_STEP_UI;
  lastSavedStep: ONBOARDING_STEP_UI;
};

const GuidedOnboardingStep: React.FC<GuidedOnboardingStepProps> = ({ stepId, lastSavedStep }) => {
  const steps = LEFT_MENU_ONBOARDING_STEPS;
  const isFirstStep = steps[0] === stepId;
  const isLastStep = steps[steps.length - 1] === stepId;
  const isVisited = isFirstStep || steps.indexOf(lastSavedStep) >= steps.indexOf(stepId);

  const renderStepIcon = () => {
    return isVisited ? OnboardingStepIconMap[stepId] : <GoPrimitiveDot className="onboarding-step-dot" size={32} />;
  };

  return (
    <div
      // tslint:disable-next-line:max-line-length
      className={`d-flex align-items-center guided-onboarding-step onboarding-step mb-4 ${
        isLastStep ? 'last-step' : ''
      } ${isVisited ? 'visited' : ''}`}
    >
      <span className="mr-2">{renderStepIcon()}</span>
      <span className="font-size-13 title">{stepId}</span>
    </div>
  );
};
